import { render } from "./V8Style.vue?vue&type=template&id=21036f5a&scoped=true"
import script from "./V8Style.vue?vue&type=script&lang=js"
export * from "./V8Style.vue?vue&type=script&lang=js"

import "./V8Style.vue?vue&type=style&index=0&id=21036f5a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21036f5a"]])

export default __exports__